module.exports = __webpack_public_path__ + "img/Pic_About.87ac0277.jpg";